import { getLeads } from "../../Leads/api/services.ts"
import { getProjects } from "../../Projects/api/services.ts"

/**
 * The one Lead/Project a "requiresRecord" step opens — fetched once per
 * tour run and reused by every later step that needs the same record, so
 * Back/Next never land on a different one (the spec's "predictable
 * selection" requirement). A fixed `page: 1, page_size: 1` request with no
 * other filters is itself what makes it predictable — the same query
 * returns the same first row every time within one session.
 *
 * Never creates a Lead/Project on the user's behalf — a null id here is a
 * real, honest "you don't have one yet", read by the tour's own fallback
 * step content instead of triggering any creation.
 */
export const resolveFirstAccessibleLead = async (): Promise<string | null> => {
  const response = await getLeads({ page: 1, page_size: 1 })
  if (!response.ok) return null
  return response.data?.results?.[0]?.id ?? null
}

export const resolveFirstAccessibleProject = async (): Promise<string | null> => {
  const response = await getProjects({ page: 1, page_size: 1 })
  if (!response.ok) return null
  return response.data?.results?.[0]?.id ?? null
}
